import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect } from 'react';
// material-ui
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TDU from '../../utils/TDU';
// assets
import { AppBar, Button, Dialog, Divider, IconButton, ListItemText, ListItemButton, List, Slide, Toolbar, Typography, TextField, FormControl, Select, MenuItem, InputLabel } from '@mui/material';

// import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
// import Components from 'Components';
// import Action from 'store/Action';
import { toast } from 'react-toastify';
import ApiCall from '../../utils/Api';
import contractABI from '../../utils/contractABI';
import Web3 from 'web3';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuDialogContent-root': {
    padding: theme.spacing(2),

  },
  '& .MuDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: "white"
        }}
      >
        {/* <CloseIcon /> */}
      </IconButton>
    ) : null}
  </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} timeout={1000} />);
export default function Provider_Email({providerEmail,setupdateCount,updateCount,ProviderSplit,ownerSplit,id,institutionName}) {
  console.log("🚀 ~ Provider_Email ~ providerEmail:", providerEmail)
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress = import.meta.env.VITE_APP_TDUcontractAddress;

  const [isconnected, setisconnected] = useState(false);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        // if (error?.response?.data?.message) {
        //            toast.error(error.response.data.message);
        //          } else {
        //            toast.error(error.message);
        //          }
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3();
  }, []);
  useEffect(() => {
    const initContract = async () => {
      try {

        const deployedContract = new web3.eth.Contract(
          TDU,
          TDUcontractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);
  const [open, setOpen] = React.useState(false);
  const [Email, setEmail] = React.useState("");
  const [EmailValidation, setEmailValidation] = React.useState("");
//   const Site_id = useSelector((state) => state.Booking.Site_id);

const updateData=async()=>{
  try {
 if(!Email){
  setEmailValidation("Please enter email")
   return
 }
 setEmailValidation("")

    console.log("Checkkkk================================>>");
    const data = await ApiCall.SECURE_API.put(`/admin/editProvider/${id}`,{
      "email" : Email,
  })
  if(data.data.success){
    toast.success("Status Updated Successfully");
  }
    console.log("🚀 ~ updateData ~ data=================:", data)
  handleClose()
  setupdateCount(updateCount+1)
  } catch (error) {
    console.log("🚀 ~ updateData ~ error:", error)

  }
    }
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };



const[SharestatusownerSplit,setSharestatusownerSplit]=useState(0)
const[SharestatusProviderSplit,setShareProviderSplit]=useState(0)
useEffect(()=>{
 setEmail(providerEmail)
},[providerEmail])
  return (
    <div>
      <Button style={{ }} variant="outlined" onClick={handleClickOpen}>
        Edit
      </Button>
      <BootstrapDialog
        fullWidth="sx"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{zIndex: (theme) => theme.zIndex.drawer + 1}} >
        <BootstrapDialogTitle
          sx={{ position: 'relative', color: 'black',fontSize:20 }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Enter Email
        </BootstrapDialogTitle>
        <DialogContent dividers>
        <div style={{}}>


            <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>

                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",marginTop:10}}>
                        <TextField value={Email} error={EmailValidation}
                           helperText={EmailValidation}
                        onChange={(e)=>{
                        setEmail(e.target.value)
                        }}
                        type="text"


                        style={{width:"90%"}} id="outlined-basic" label="Enter Email" variant="outlined" />
                        
                        </div>
                 </div>






      </div>

        </DialogContent>
        <DialogActions>
          <Button style={{ }} onClick={updateData} autoFocus >
            SAVE
          </Button>
          <Button style={{ }} onClick={handleClose} autoFocus >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
